module.exports = __webpack_public_path__ + "static/media/edit.8fd58722.svg";